import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** When Router ignores same-URL navigations, the assessment page applies this intent (refresh notes / open comments). */
export interface NotificationAssessmentIntentPayload {
    assessmentId: string;
    sectionId?: string;
    assessmentQuestionId?: string;
    notesThreadId?: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationAssessmentIntentService {
    readonly openAssessmentFromNotification$ = new Subject<NotificationAssessmentIntentPayload>();

    /** Fired when an `AiTemplateReady` bell arrives, so the templates gallery can refetch and show the
     *  newly-created template without a manual refresh. */
    readonly aiTemplateReady$ = new Subject<void>();

    emitOpenAssessmentFromNotification(payload: NotificationAssessmentIntentPayload): void {
        this.openAssessmentFromNotification$.next(payload);
    }

    emitAiTemplateReady(): void {
        this.aiTemplateReady$.next();
    }
}
